<template>
  <v-dialog
    max-width="800px"
    v-model="addAgent"
    persistent
    v-if="slackUsers.length != 0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="secondary"
        fab
        small
        dark
        class="mb-2"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-plus </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          <v-icon>mdi-account</v-icon>Add new agent</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-row>
          <v-col v-if="error">
            <v-alert
              type="error"
              dismissible
              v-model="error"
              transition="scale-transition"
            >
              {{ error }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col>
            <v-text-field
              v-model="firstName"
              label="First name"
              prepend-icon="mdi-account"
              dense
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="lastName"
              label="Last name"
              prepend-icon="mdi-account"
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="email"
              label="Email"
              prepend-icon="mdi-email"
              dense
            ></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="slackId"
              :items="slackUsers"
              prepend-icon="mdi-message-text"
              label="Slack Bind"
              item-text="name"
              item-value="id"
              dense
            >
              <template v-slot:selection="{ item }">
                <div class="flag">
                  <img class="flag" :src="item.image" alt="" />
                </div>
                {{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                <div class="flag">
                  <img class="flag" :src="item.image" alt="" />
                </div>
                {{ item.name }}
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="zendeskId"
              label="Zendesk ID"
              prepend-icon="mdi-account"
              dense
            ></v-text-field>
          </v-col>
          <v-col>
            <v-select
              v-model="team"
              :items="teams"
              prepend-icon="mdi-account-group"
              label="Team"
              dense
              item-text="team"
              item-value="id"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model="country"
              dense
              label="Country"
              :items="countries"
              item-text="name"
              prepend-icon="mdi-map"
              item-value="code"
            >
              <template v-slot:selection="{ item }">
                <div class="flag">
                  <img
                    :src="`https://catamphetamine.gitlab.io/country-flag-icons/3x2/${item.code}.svg`"
                    class="flag"
                  />
                </div>
                {{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                <div class="flag">
                  <img
                    :src="`https://catamphetamine.gitlab.io/country-flag-icons/3x2/${item.code}.svg`"
                    class="flag"
                  />
                </div>
                {{ item.name }}
              </template>
            </v-select>
          </v-col>
          <v-col>
            <v-switch v-model="canLogin" label="Can Login" dense></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="addAgent = false">Cancel</v-btn>
        <v-btn color="success" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import countriesJson from "@/assets/countries.json";
import axios from "@/plugins/axios";
export default {
  data() {
    return {
      countries: countriesJson,
      teams: [],
      slackUsers: [],
      firstName: "",
      lastName: "",
      email: "",
      slackId: undefined,
      zendeskId: "",
      team: "",
      canLogin: false,
      error: null,
      country: "",
      addAgent: false,
    };
  },
  methods: {
    save() {
      let that = this;
      axios
        .post("/api/v1/agents/add", {
          firstName: that.firstName,
          lastName: that.lastName,
          email: that.email,
          slack_id: that.slackId,
          zendesk_id: that.zendeskId,
          team: that.team,
          country: that.country,
          canLogin: that.canLogin,
        })
        .then(() => {
          this.addAgent = false;
          this.$emit("refresh");
        })
        .catch((err) => {
          that.error = err.response.data;
        });
    },
  },
  created() {
    let that = this;
    axios.get("/api/v1/teams/list").then((res) => {
      that.teams = res.data;
    });
    axios.get("/api/v1/slack/users").then((res) => {
      that.slackUsers = res.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.flag {
  height: 24px;
  padding-right: 5px;
}
</style>
